import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/manual_help_videos.jpg'
import _imports_1 from '@/assets/images/manual_trails.jpg'
import _imports_2 from '@/assets/images/manual_trace.jpg'
import _imports_3 from '@/assets/images/manual_download.jpg'
import _imports_4 from '@/assets/images/manual_manage_maps.jpg'
import _imports_5 from '@/assets/images/manual_distance.jpg'
import _imports_6 from '@/assets/images/manual_record.jpg'
import _imports_7 from '@/assets/images/manual_print.jpg'
import _imports_8 from '@/assets/images/manual_waypoints.jpg'
import _imports_9 from '@/assets/images/manual_trail_segments.jpg'
import _imports_10 from '@/assets/images/manual_pro.jpg'
import _imports_11 from '@/assets/images/manual_share.jpg'
import _imports_12 from '@/assets/images/manual_export.jpg'
import _imports_13 from '@/assets/images/manual_import.jpg'
import _imports_14 from '@/assets/images/manual_mapTypes.jpg'
import _imports_15 from '@/assets/images/manual_tags.jpg'
import _imports_16 from '@/assets/images/manual_sync.jpg'
import _imports_17 from '@/assets/images/manual_plan_trip.jpg'
import _imports_18 from '@/assets/images/maunal_custom_routes.jpg'
import _imports_19 from '@/assets/images/maunal_natural_atlas.jpg'
import _imports_20 from '@/assets/images/maunal_hunting_overlays.jpg'
import _imports_21 from '@/assets/images/manual_photo_overlays.jpg'
import _imports_22 from '@/assets/images/manual_data_overlyas.jpg'
import _imports_23 from '@/assets/images/manual_grid_overlays.jpg'
import _imports_24 from '@/assets/images/manual_map_overlays.jpg'
import _imports_25 from '@/assets/images/maunal_neoTreks_maps.jpg'
import _imports_26 from '@/assets/images/manual_regions.jpg'
import _imports_27 from '@/assets/images/manual_energy_usage.jpg'
import _imports_28 from '@/assets/images/manual_coordinateSearch.jpg'
import _imports_29 from '@/assets/images/manual_guideMe.jpg'
import _imports_30 from '@/assets/images/manual_troubleShooting.jpg'
import _imports_31 from '@/assets/images/manual_distanceFromLoc.jpg'
import _imports_32 from '@/assets/images/manual_notes.jpg'
import _imports_33 from '@/assets/images/AppleWatch.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("section", { class: "features-section" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/help-videos/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_0,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Help Videos ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/2016/05/trail-overlays/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_1,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Interact with Trails ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/plan-next-adventure/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_2,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Trace New Trails ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/using-topo-maps-offline/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_3,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/using-topo-maps-offline/" }, "Download Maps")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/using-topo-maps-offline/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_4,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/2017/01/managing-downloaded-maps/" }, "Manage Downloaded Maps")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/measuring-distance-map/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Measure Distance ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/record-a-trip/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_6,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Record Your Tracks ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/using-topo-maps-offline/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_7,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/2016/05/printing-topo-maps/" }, "Print Maps")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/using-topo-maps-offline/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_8,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/waypoints/" }, "Waypoints")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/trail-segments-and-progress-on-trail/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_9,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Trail Segments & Progress on Trail ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/2016/10/topo-maps-pro/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_10,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/2016/10/topo-maps-pro/" }, "Topo Maps+ PRO")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/using-topo-maps-offline/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_11,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/share-friends/" }, "Share with Your Friends")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/export-apps/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_12,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Export to Other Apps ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/2014/07/import-from-other-apps/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_13,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Import from Other Apps ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/topo-maps-works-many-different-map-types/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_14,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Map Types ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/organize-beautiful-tags/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_15,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Organize with Categories ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/2016/08/syncing-topo-maps-data/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_16,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Syncing Data Between Devices ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/2016/08/how-i-use-topo-maps-to-plan-a-trip/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_17,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("How to Plan a Trip in Topo Maps+ ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/custom-routes/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_18,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Custom Routes ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/natural-atlas/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_19,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Natural Atlas ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/us-hunting-unit-overlays/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_20,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("US Hunting Overlays ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/photo-overlays/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_21,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Photo Overlays ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/data-overlays/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_22,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Data Overlays ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/grid-overlays/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_23,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Grid Overlays ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/map-overlays/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_24,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Map Overlays ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/neotreks-maps/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_25,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("NeoTreks Maps ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/regions/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_26,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Regions ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/2016/08/three-days-of-use-on-one-battery-charge/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_27,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Maximize Battery Life ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/coordinate-search-format/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_28,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Coordinate Search Format ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/guide-me/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_29,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Guide Me ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/2016/08/what-to-do-when-topo-maps-stops-working/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_30,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("What to do when Topo Maps+ stops working. ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/distance-and-heading-from-current-location/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_31,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Distance and Heading from Current Location ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/taking-notes-in-topo-maps//" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_32,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Taking Notes ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-12",
      style: {"height":"260px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://www.support.glacierpeak.app/topo-maps-on-the-apple-watch/" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_33,
          height: "200",
          width: "200",
          class: "img-fluid",
          style: {"float":"left"}
        }),
        /*#__PURE__*/_createElementVNode("h4", null, [
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("Topo Maps+ on Apple Watch ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "features-section justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-sm justify-content-center text-center" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "section_heading" }, [
        /*#__PURE__*/_createElementVNode("h3", { class: "wow" }, "Have more questions?"),
        /*#__PURE__*/_createElementVNode("hr", { class: "separator" })
      ]),
      /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"20pt"} }, [
        /*#__PURE__*/_createTextVNode(" Email us at "),
        /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@glacierPeakStudios.com" }, "support@glacierPeakStudios.com"),
        /*#__PURE__*/_createTextVNode(". ")
      ])
    ])
  ])
], -1)

import IntroHeader from "@/components/IntroHeader.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(IntroHeader),
    _hoisted_1,
    _hoisted_2
  ]))
}
}

})